export default "__VITE_ASSET__B9lwq1TO__"